export default __webpack_public_path__ + "static/media/blurred-exp.d4c36018.png";